import { render, staticRenderFns } from "./RemoteSetupSlide.vue?vue&type=template&id=57bf50f6&scoped=true"
import script from "./RemoteSetupSlide.vue?vue&type=script&lang=js"
export * from "./RemoteSetupSlide.vue?vue&type=script&lang=js"
import style0 from "./RemoteSetupSlide.vue?vue&type=style&index=0&id=57bf50f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bf50f6",
  null
  
)

export default component.exports